import "./scss/main.scss";

// This needs to remain although it's unused in this file
import * as bootstrap from 'bootstrap';

import "./js/main.js";
